import { render, staticRenderFns } from "./send-red-packets.vue?vue&type=template&id=255a1109&scoped=true&"
import script from "./send-red-packets.vue?vue&type=script&lang=js&"
export * from "./send-red-packets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255a1109",
  null
  
)

export default component.exports